import { render, staticRenderFns } from "./ForceVectorViz.vue?vue&type=template&id=b79ecd98&scoped=true"
import script from "./ForceVectorViz.vue?vue&type=script&lang=js"
export * from "./ForceVectorViz.vue?vue&type=script&lang=js"
import style0 from "./ForceVectorViz.vue?vue&type=style&index=0&id=b79ecd98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79ecd98",
  null
  
)

export default component.exports